// removed by extract-text-webpack-plugin
module.exports = {"medium-grey":"#9f9f9f","background-grey":"#f6f6f6","black":"#000000","white":"#ffffff","red":"#e40000","normal":".3s","fastest":".15s","desktop":"1366px","container":"GzLGL65oxmjws-m-89Wdd","withoutDivider":"_3A-4o-6yZcKF8InpeqvN0M","aligned":"_1H9O7-GUI-A4bbWyrB_1zf","link":"_2aeJqzWdAyRj3yqAswqTNm","information":"_18OnixSdk4VBzl6pTyFyDO","action":"_3QyUvH3iAnrInsoQmGnuCd"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Footer/StandardFooter/StandardFooter.css
// module id = 1199
// module chunks = 0